<template>
  <div class="flex items-start justify-between gap-4">
    <div>
      <div class="title-bar">
        <slot v-if="$slots['default']" />

        <div
          v-else
          class="title text-xl font-semibold md:text-2xl">
          {{ title }}
        </div>

        <slot
          v-if="$slots['view-all']"
          name="view-all" />

        <slot
          v-if="$slots['tabs']"
          name="tabs" />
      </div>
    </div>
    <slot
      v-if="$slots['right']"
      name="right"
      class="width-fit" />

    <div
      v-if="geoData && geoData.length > 1 && !$slots['right']"
      class="mt-2 flex items-center justify-between gap-y-6">
      <topline-table-select
        class="county-dropdown"
        :geo-type="geoLabel"
        :geo-data="geoData" />
    </div>
  </div>
  <div
    v-if="geoData && geoData.length > 1 && $slots['right']"
    class="mt-2 flex flex-wrap items-center justify-between gap-2 gap-y-6">
    <div class="county-dropdown">
      <topline-table-select
        :geo-type="geoLabel"
        :geo-data="geoData" />
    </div>
  </div>
</template>

<script>
import { ToplineTableSelect } from "./toplineWidgets";

import { capitalize } from "@/filters";
import { mapGetters } from "vuex";

const components = {
  ToplineTableSelect,
};

const props = {
  results: {
    type: Object,
    required: true,
  },
  embedTitle: {
    required: false,
  },
  title: {
    type: String,
    required: false,
  },
  geoType: {
    type: String,
    required: false,
    default: "county",
  },
  geoData: {
    type: Array,
    required: false,
  },
};

const computed = {
  ...mapGetters(["params"]),
  geoLabel() {
    // TODO: probably move this to parse file
    let geoLabel = "county";
    if (this.geoType === "vcu") {
      geoLabel = "township";
    }
    if (this.results.state_name === "Louisiana") {
      geoLabel = "parish";
    }
    return capitalize(geoLabel);
  },
  geoSelection() {
    return this.$store.getters.geoSelection;
  },
  selectedGeoResults() {
    if (typeof this.geoSelection === "undefined" || this.geoSelection === null || !this.geoData) {
      return this.results;
    }
    return this.geoData.find(
      (d) => d[this.geoType].toLowerCase() === this.geoSelection.toLowerCase()
    );
  },
  isLA() {
    return this.results.state === "LA" && this.results.race_date === "2023-10-14";
  },
};

export default {
  components,
  props,
  computed,
};
</script>

<style>
.title-bar {
  align-items: baseline;
  display: inline-flex;
  gap: 1em;
  width: 100%;
}

.title {
  line-height: 25px;
}

@media screen and (max-width: 700px) {
  .title-bar {
    flex-direction: column;
  }

  .align-tab-item {
    left: 0;
  }
}

.polls-close {
  font-size: 16px;
}
</style>
